import * as React from 'react';

function SvgVentilator(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76.4 77.1" {...props}>
      <path
        className="ventilator_svg__st0"
        d="M58 21.8c-8.8-.9-17 4.6-19.5 13.1h-.1c-.6 0-1.2.2-1.7.4-1.4-7.4 1.8-14.9 8.1-19 2.4-2.4 3.1-6 1.7-9-1.4-3-4.7-4.9-8-4.5-8.9.6-16.1 7.5-17 16.4-.9 8.8 4.6 17 13.1 19.5v.1c0 .6.2 1.2.4 1.7-7.5 1.5-15-1.7-19-8.1-2.3-2.4-6-3.1-9-1.6-3.1 1.4-4.9 4.7-4.5 8 .6 8.9 7.5 16.1 16.4 17 8.8.9 17-4.6 19.5-13.1h.1c.6 0 1.2-.2 1.7-.4 1.5 7.4-1.7 14.9-8.1 19-2.4 2.3-3.1 6-1.6 9 1.4 3.1 4.6 4.9 8 4.5 8.9-.6 16.1-7.5 17-16.4.9-8.8-4.6-17-13.1-19.5v-.1c0-.6-.2-1.2-.4-1.7 7.4-1.5 14.9 1.7 18.9 8.1 2.4 2.4 6 3.1 9 1.6 3.1-1.5 4.8-4.7 4.5-8-.6-8.9-7.6-16.1-16.4-17z"
      />
      {props.style?.transform !== 'none' && (
        <animateTransform
          accumulate="none"
          additive="replace"
          attributeName="transform"
          begin="0s"
          calcMode="linear"
          dur="5s"
          fill="remove"
          from="0 0 0"
          repeatCount="indefinite"
          restart="always"
          to="360 0 0"
          type="rotate"
        />
      )}
    </svg>
  );
}

export default SvgVentilator;
